import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { errorHandler, getContent, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { CheckPermissionApi, CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE, TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE_ASSIGNEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketIssueCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            complaint: {
                page: 1,
                limit: 100,
                data: [],
                value: ''
            },
            complaintCategory: {
                page: 1,
                limit: 100,
                data: [],
                value: ''
            },
            complaintSub: {
                page: 1,
                limit: 100,
                data: [],
                value: ''
            },
            showGetListComplaint: false,
            showGetListComplaintCategory: false,
            showGetListComplaintSub: false,
            isEditIssueCategory: false,
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListComplaint = () => {
        API_TICKET_LIST.getListComplaint(this.state.complaint.page, this.state.complaint.limit, this.props.token)
            .then(res => {
                this.setState({
                    complaint: {
                        ...this.state.complaint,
                        data: getContent(res)
                    }
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    getListComplaintCategory = id => {
        API_TICKET_LIST.getListComplaintCategory(this.state.complaintCategory.page, this.state.complaintCategory.limit, id, this.props.token)
            .then(res => {
                this.setState({
                    complaintCategory: {
                        ...this.state.complaintCategory,
                        data: getContent(res)
                    }
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    getListComplaintSub = id => {
        API_TICKET_LIST.getListComplaintSub(this.state.complaintSub.page, this.state.complaintSub.limit, id, this.props.token)
            .then(res => {
                this.setState({
                    complaintSub: {
                        ...this.state.complaintSub,
                        data: getContent(res)
                    }
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleChangeComplaint = e => {
        this.props.canEscalate(false)
        this.setState({
            complaint: {
                ...this.state.complaint,
                value: e.target.value
            },
            complaintCategory: {
                ...this.state.complaintCategory,
                value: ''
            },
            complaintSub: {
                ...this.state.complaintSub,
                value: ''
            },
            isEditIssueCategory: true
        })
    }

    handleChangeComplaintCategory = e => {
        this.props.canEscalate(false)
        this.setState({
            complaintCategory: {
                ...this.state.complaintCategory,
                value: e.target.value
            }
        })
    }

    handleChangeComplaintSub = e => {
        this.props.canEscalate(false)
        this.setState({
            complaintSub: {
                ...this.state.complaintSub,
                value: e.target.value
            },
            showConfirmAlert: true
        })
    }

    handleSubmit = () => {
        const data = {
            complaint_sub_id: parseInt(this.state.complaintSub.value),
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataTicketComplaint(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false
                })
                this.props.canEscalate(true)
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                setTimeout(() => this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL), 1500)
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            }))
    }

    handleGetComplaint = () => {
        this.setState({
            showGetListComplaint: true
        })
        this.getListComplaint()
    }

    handleGetComplaintCategory = () => {
        this.setState({
            showGetListComplaintCategory: true
        })
        this.getListComplaintCategory(this.state.complaint.value)
    }

    handleGetComplaintSub = () => {
        this.setState({
            showGetListComplaintSub: true
        })
        this.getListComplaintSub(this.state.complaintCategory.value)
    }

    issueCategoryReadOnly = () => {
        return (
            <>
                <select id="ddlcomplaint" className="outline-none custom-select select-rtl my-1" disabled>
                    <option className="option-rtl">{this.props.data.complaint}</option>
                </select>
                <select id="ddlcomplaintcategory" className="outline-none custom-select select-rtl my-1" disabled>
                    <option className="option-rtl">{this.props.data.complaint_category}</option>
                </select>
                <select id="ddlcomplaintsub" className="outline-none custom-select select-rtl my-1 w-full truncate" title={this.props.data.complaint_sub} disabled>
                    <option>{this.props.data.complaint_sub}</option>
                </select>
            </>
        )
    }

    checkCustomerServiceAssignee = () => {
        if (CheckPermissionApi(TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE, this.props.userDetail.permissions)) {
            return true
        }
        
        if (CheckPermissionApi(TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE_ASSIGNEE, this.props.userDetail.permissions)) {
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false
            return true
        }
    }

    render() {
        return (
            <div className="flex flex-col justify-center items-end">
                {
                    this.checkCustomerServiceAssignee()
                        ? <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE, TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                            <select id="ddlcomplaint" className="outline-none custom-select select-rtl my-1" onChange={this.handleChangeComplaint} onClick={() => this.handleGetComplaint()}>
                                {this.state.showGetListComplaint && <option className="option-rtl">- Pilih Complaint -</option>}
                                {
                                    this.state.complaint.data.length !== 0 ?
                                        this.state.complaint.data.map(data =>
                                            <option key={data.id} className="option-rtl" value={data.id}>{data.complaint_description}</option>
                                        )
                                        :
                                        <option className="option-rtl">{this.props.data.complaint}</option>
                                }
                            </select>
                            <select id="ddlcomplaintcategory" className="outline-none custom-select select-rtl my-1" onChange={this.handleChangeComplaintCategory} onClick={() => this.handleGetComplaintCategory()} disabled={!this.state.isEditIssueCategory}>
                                {this.state.showGetListComplaintCategory && <option className="option-rtl">- Pilih Complaint Category -</option>}
                                {
                                    this.state.complaintCategory.data.length !== 0 ?
                                        this.state.complaintCategory.data.map(data =>
                                            <option key={data.id} className="option-rtl" value={data.id}>{data.complaint_category}</option>
                                        )
                                        :
                                        <option className="option-rtl">{this.state.isEditIssueCategory ? '- Pilih Complaint Category -' : this.props.data.complaint_category}</option>
                                }
                            </select>
                            <select id="ddlcomplaintsub" className="outline-none custom-select select-rtl my-1" onChange={this.handleChangeComplaintSub} onClick={() => this.handleGetComplaintSub()} disabled={!this.state.isEditIssueCategory}>
                                {this.state.showGetListComplaintSub && <option className="option-rtl">- Pilih Complaint Sub -</option>}
                                {
                                    this.state.complaintSub.data.length !== 0 ?
                                        this.state.complaintSub.data.map(data =>
                                            <option key={data.id} className="option-rtl" value={data.id}>{data.complaint_sub}</option>
                                        )
                                        :
                                        <option className="option-rtl">{this.state.isEditIssueCategory ? '- Pilih Complaint Sub -' : this.props.data.complaint_sub}</option>
                                }
                            </select>
                        </CheckPermissionComponent>
                        : <this.issueCategoryReadOnly />
                }
                <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin melakukan perubahan kategori issue?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleSubmit()} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketIssueCategory));